import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow-information",
  "use": "icon-down-arrow-information-usage",
  "viewBox": "0 0 18.148 9.584",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.148 9.584\" id=\"icon-down-arrow-information\">\n  <path id=\"icon-down-arrow-information_np_chevron_933251_000000\" d=\"M43.427,28.48l-.658-.769-7.118-8.3-1.807,1.539L40.3,28.48l-6.46,7.535,1.807,1.539,7.118-8.3Z\" transform=\"translate(37.554 -33.843) rotate(90)\" fill=\"#d7d7d7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/down-arrow-information.svg
// module id = 125
// module chunks = 0 1 2